import { Flex } from "src/components/Flex";
import styled from "styled-components";

export const Wrapper = styled(Flex)`
  flex: 1;
  width: 100%;
  min-width: 0;
`;
